export default __webpack_public_path__ + "static/Web-camera-amazon-main-diagram-EN-2-6d09401b435407f4bb741684f3381789.webp";